<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <div class="card-content">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.filter_name"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter for</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select v-model="form.m" v-validate="'required'" name="m">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in tblList"
                  />
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('m')">{{
                  errors.first("m")
                }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";
import { currencyList } from "@/utils/Constants";

export default {
  components: {},
  data: () => ({
    timezones: timezones,
    valid: true,
    form: {
      filter_name: "",
      filter_slug: "",
      m: "",
      publish_status: true,
      listing_status: true,
      admin_status: true,
      weight: 100,
    },
    tblList: [
      { name: "Booth", value: "booth" },
      { name: "Company", value: "company" },
      { name: "Speaker", value: "speaker" },
      { name: "Sponsor", value: "sponsor" },
    ],
  }),
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
      };

      this.form.filter_slug = this.slug(
        this.form.m + " " + this.form.filter_name + " " + this.generateNumber()
      );

      this.form = { ...this.form, ...data };

      this.$vs.loading();
      Service.Filter.create(this.form)
        .then((res) => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Process complete.",
              color: "success",
            });
            this.$router.push("/conferences/filters");
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    slug(word) {
      let resp = word
        .toLowerCase() // LowerCase
        .replace(/\s+/g, "-") // space to -
        .replace(/&/g, `-and-`) // & to and
        .replace(/--/g, `-`); // -- to -
      return resp;
    },
    generateNumber: function () {
      return Math.floor(Math.random() * (99999999 - 10000000 + 1) + 10000000);
    },
  },
};
</script>